import React, { useState } from "react";
import { useQuery, useMutation, gql } from "@apollo/client";
import { Dialog, Checkbox, Spinner, Pane, Text, toaster } from "evergreen-ui";
import { FieldBtn } from "../../dues/dues.style";

const GET_DUES_BY_FACILITY_EXCLUDING_PROPERTY = gql`
  query Dues_getByFacilityExcludingProperty($facilityId: ID!, $propertyId: ID!) {
    dues_getByFacilityExcludingProperty(facilityId: $facilityId, propertyId: $propertyId) {
      _id
      title
      startDate
      properties
      defaultAmount
    }
  }
`;

const ADD_DUES_TO_PROPERTIES = gql`
  mutation Dues_addNewProperties($dueIds: [ID!]!, $propertyIds: [ID!]!) {
    dues_addNewProperties(dueIds: $dueIds, propertyIds: $propertyIds) {
      code
      success
      error
    }
  }
`;

const DuesModal = ({ facilityId, propertyIds }) => {
  const [isDialogShown, setIsDialogShown] = useState(false);
  const [selectedDues, setSelectedDues] = useState([]);

  const { loading, data } = useQuery(GET_DUES_BY_FACILITY_EXCLUDING_PROPERTY, {
    variables: { facilityId, propertyId: propertyIds[0] }, // Assuming single property for simplicity
    skip: !isDialogShown,
  });

  const [addDuesToProperties, { loading: mutationLoading }] = useMutation(
    ADD_DUES_TO_PROPERTIES,
    {
      onCompleted: (response) => {
        if (response.dues_addNewProperties.success) {
          toaster.success("Dues added successfully!");
          setIsDialogShown(false);
          setSelectedDues([]);
          window.location.reload();
        } else {
          toaster.danger(response.dues_addNewProperties.error || "Failed to add dues.");
        }
      },
      onError: (error) => {
        toaster.danger(error.message);
      },
    }
  );

  const handleCheckboxChange = (dueId) => {
    setSelectedDues((prev) =>
      prev.includes(dueId) ? prev.filter((id) => id !== dueId) : [...prev, dueId]
    );
  };

  const handleSubmit = () => {
    if (selectedDues.length === 0) {
      toaster.warning("No dues selected.");
      return;
    }

    addDuesToProperties({ variables: { dueIds: selectedDues, propertyIds } });
  };

  return (
    <Pane>
      <FieldBtn onClick={() => setIsDialogShown(true)} className="waves-effect waves-light btn-flat">
        Add Dues
      </FieldBtn>

      <Dialog
        isShown={isDialogShown}
        title="Select Dues for Properties"
        onCloseComplete={() => setIsDialogShown(false)}
        confirmLabel="Add Selected Dues"
        isConfirmLoading={mutationLoading}
        onConfirm={handleSubmit}
        cancelLabel="Cancel"
      >
        {loading ? (
          <Spinner />
        ) : (
          <Pane>
            {data?.dues_getByFacilityExcludingProperty?.length > 0 ? (
              data.dues_getByFacilityExcludingProperty.map((due) => (
                <Pane key={due._id} marginBottom={16}>
                  <Checkbox
                    label={
                      <Pane>
                        <Text fontWeight={600}>{due.title}</Text>
                        <Text color="muted" size={300}>
                          {" "}
                          - {due.defaultAmount} (Start: {new Date(due.startDate).toLocaleDateString()})
                        </Text>
                      </Pane>
                    }
                    checked={selectedDues.includes(due._id)}
                    onChange={() => handleCheckboxChange(due._id)}
                  />
                </Pane>
              ))
            ) : (
              <Text>No dues available for this facility.</Text>
            )}
          </Pane>
        )}
      </Dialog>
    </Pane>
  );
};

export default DuesModal;
